import { useFormContext } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { InvitationFormValues } from '@/types/invitation-schema';
import { useEvent } from '@/hooks/useEvent';
import { ESTILO_OPCIONES, toEstilo } from '@/invitation/payload/styles';
import { cn } from '@/lib/utils';

const CoupleTab = () => {
  const form = useFormContext<InvitationFormValues>();
  const { template_id } = form.watch();
  // 006: nombres/fecha son del Evento (fuente única), no se editan aquí.
  const { data: event } = useEvent();
  const bride_name = event?.bride_name ?? '';
  const groom_name = event?.groom_name ?? '';
  const wedding_date = event?.wedding_date ? event.wedding_date.slice(0, 10) : '';

  // 004: el estilo (uno de 7 del Design System) vive en la invitación (`template_id`).
  const estiloActual = toEstilo(template_id);
  const handleEstiloChange = (estiloId: string) => {
    form.setValue('template_id', estiloId as InvitationFormValues['template_id'], { shouldDirty: true });
  };

  return (
    <div className="grid gap-6 md:grid-cols-2">
      <Card>
        <CardHeader>
          <CardTitle>Datos de los Novios</CardTitle>
          <CardDescription>
            Los nombres y la fecha se gestionan en <strong>Mi boda</strong> (son la fuente única del evento).
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-lg border border-border p-4 space-y-1 text-sm">
            <p><span className="text-muted-foreground">Novia:</span> {bride_name || '—'}</p>
            <p><span className="text-muted-foreground">Novio:</span> {groom_name || '—'}</p>
            <p><span className="text-muted-foreground">Fecha:</span> {wedding_date || '—'}</p>
          </div>
          <Button asChild variant="outline" size="sm">
            <Link to="/dashboard/wedding">Editar en “Mi boda”</Link>
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Estilo de la invitación</CardTitle>
          <CardDescription>Elige uno de los 7 estilos disponibles</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {ESTILO_OPCIONES.map((estilo) => (
              <button
                key={estilo.id}
                type="button"
                onClick={() => handleEstiloChange(estilo.id)}
                className={cn(
                  'rounded-lg border p-3 text-sm text-center transition-all',
                  'hover:border-primary/60',
                  estiloActual === estilo.id
                    ? 'border-primary ring-2 ring-primary/20 bg-primary/5'
                    : 'border-border',
                )}
              >
                {estilo.nombre}
              </button>
            ))}
          </div>
          <p className="text-xs text-muted-foreground">
            El estilo define paleta, tipografía y ornamentos. Ve el resultado en la pestaña “Vista Previa”.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default CoupleTab;
